import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { useAuth } from "context/authContext";
import LoadingScreen from "components/Loading";

const SignInProtectionRoute = ({ children }) => {
  const { isAuthenticated, checkLoggedInStatus } = useAuth();
  const [loading, setLoading] = useState(true);
  const location = useLocation(); // Get the current location
  useEffect(() => {
    const fetchData = async () => {
      await checkLoggedInStatus();
      setLoading(false); // Stop loading after authentication check
    };

    fetchData();
  }, [isAuthenticated]);

  if (loading) {
    return <LoadingScreen />;
  }

  // If authenticated, redirect to the originally requested page
  if (isAuthenticated) {
    return <Navigate to={location.state?.from || "/dashboard"} replace />;
  }

  return <>{children}</>;
};

SignInProtectionRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SignInProtectionRoute;
